/**
 * Lite 導向共用（SSOT）
 * Group 脈絡下跳轉時保留 groupId 於 query
 */

import { getGroupIdFromUrl } from './getGroupIdFromUrl.js';

/**
 * 將 path 附加 groupId query（有 groupId 時）
 * @param path 目標路徑（可含既有 query）
 * @param groupId 若未傳則從 getGroupIdFromUrl() 取得
 */
export function appendGroupIdToPath(
  path: string,
  groupId?: string | null
): string {
  const id = groupId ?? getGroupIdFromUrl();
  if (!id?.trim()) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}groupId=${encodeURIComponent(id.trim())}`;
}
